// DO NOT EDIT THIS FILE, EDIT THE WEBPACK COMMON CONFIG INSTEAD, WHICH WILL MODIFY THIS FILE
let _VERSION = '0.0.0'; // This value will be overwritten by webpack
let _DEBUG_INFO_ENABLED = true; // This value will be overwritten by webpack
_VERSION = "0.0.0";
_DEBUG_INFO_ENABLED = false;
export const VERSION = _VERSION;
export const DEBUG_INFO_ENABLED = _DEBUG_INFO_ENABLED;
export const SERVER_FILE_API_URL = 'http://192.168.4.90:8080/api/files-no-authenticate/';
export const PAGE_TITLE_SUFFIX = ' | Télérecours Citoyens | Conseil d\'État'



// WEBPACK FOOTER //
// ./~/string-replace-webpack-plugin/loader.js?id=0i9lv4ucg73i!./src/main/webapp/app/app.constants.ts